/* The bag drawer.
 *
 * Lives outside the panel it controls, because the panel's contents are
 * replaced wholesale after every change and a listener inside them would go
 * with it.
 *
 * Everything here is an enhancement over markup that already works. The bag
 * in the header is a real link to /cart and the product form is a real form;
 * if this file never loads, or throws, the shop behaves as it did before.
 * That is why each interception checks for what it needs before calling
 * preventDefault, and why a failed fetch falls through to the ordinary
 * submit rather than leaving somebody staring at a button that did nothing.
 */
(function () {
  var drawer = document.getElementById('CartDrawer');
  if (!drawer || !window.fetch) return;

  var body = document.getElementById('CartDrawerBody');
  var opener = null;

  function open() {
    opener = document.activeElement;
    drawer.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var focusable = drawer.querySelector('[data-drawer-close], a, button');
    if (focusable) focusable.focus();
    document.addEventListener('keydown', onKey);
  }

  function close() {
    drawer.hidden = true;
    document.documentElement.style.overflow = '';
    document.removeEventListener('keydown', onKey);
    if (opener && opener.focus) opener.focus();
  }

  function onKey(event) {
    if (event.key === 'Escape') close();
  }

  /* Re-render from Liquid rather than rebuilding here. Money formats, the
     free-postage sentence and the variant titles all stay in one place. */
  function refresh() {
    return fetch(window.Shopify.routes.root + '?sections=cart-drawer&_=' + Date.now(),
                 { cache: 'no-store' })
      .then(function (response) { return response.json(); })
      .then(function (sections) {
        var html = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        var fresh = html.getElementById('CartDrawerBody');
        if (fresh) body.innerHTML = fresh.innerHTML;
        /* The count comes from the drawer's own data attribute, not from a
           header that is not in this section. Looking for .bag .count in the
           fetched markup found nothing every time and quietly removed the
           number from the page. */
        var bag = document.querySelector('.bag');
        if (!bag || !fresh) return;
        var count = parseInt(fresh.getAttribute('data-count'), 10) || 0;
        var badge = bag.querySelector('.count');
        if (count > 0) {
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'count';
            badge.setAttribute('aria-hidden', 'true');
            bag.appendChild(badge);
          }
          badge.textContent = count;
        } else if (badge) {
          badge.remove();
        }
      });
  }

  document.addEventListener('click', function (event) {
    var closer = event.target.closest('[data-drawer-close]');
    if (closer) {
      event.preventDefault();
      close();
      return;
    }

    var bag = event.target.closest('.bag');
    if (bag) {
      event.preventDefault();
      open();
      refresh();
    }
  });

  /* + / - / Remove. One request, then the panel is re-rendered from Liquid,
     so the line, the subtotal and the free-postage sentence all come back
     from the same source rather than being adjusted here by arithmetic.
     A refusal, which is Shopify saying there is no more stock, still
     re-renders so the numbers on screen are the true ones, and then says
     why the + did nothing. */
  drawer.addEventListener('click', function (event) {
    var control = event.target.closest('[data-qty]');
    if (!control || control.disabled) return;
    var line = control.closest('[data-line]');
    if (!line) return;

    event.preventDefault();
    drawer.setAttribute('aria-busy', 'true');
    var refused = false;

    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        line: Number(line.dataset.line),
        quantity: Number(control.dataset.qty)
      })
    })
      .then(function (response) { refused = !response.ok; })
      .catch(function () { refused = true; })
      .then(refresh)
      .then(function () {
        drawer.removeAttribute('aria-busy');
        var note = drawer.querySelector('.bagd__note');
        if (note && refused) note.textContent = drawer.dataset.limit || '';
      });
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.action || form.action.indexOf('/cart/add') === -1) return;

    event.preventDefault();
    var button = form.querySelector('[type="submit"]');
    if (button) button.disabled = true;

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      body: new FormData(form),
    })
      .then(function (response) {
        if (!response.ok) throw new Error('refused');
        return refresh();
      })
      .then(open)
      .catch(function () {
        /* Sold out, a race on the last jar, or the network. Let the ordinary
           form submission happen so the shopper sees Shopify's own message
           rather than nothing at all. */
        form.submit();
      })
      .then(function () {
        if (button) button.disabled = false;
      });
  });
})();
